import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";

const inp = "h-9 w-full rounded-lg border border-[#E2E8F0] bg-white px-2.5 text-sm dark:border-[#223139] dark:bg-white/5 dark:text-white";

export function RescheduleButton({ appt, onDone }) {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState((appt.date || "").slice(0, 10));
  const [time, setTime] = useState(appt.time || "09:00");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.post(`/appointments/${appt.id}/reschedule`, { date, time, reason }); toast.success("Appointment rescheduled"); setOpen(false); onDone?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't reschedule"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <span className="inline-flex items-center gap-1.5">
        {appt.rescheduled && <span className="rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-bold text-sky-700 dark:bg-sky-500/15 dark:text-sky-300" data-testid={`appt-rescheduled-${appt.id}`}>Rescheduled</span>}
        <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`appt-reschedule-${appt.id}`}><CalendarClock className="mr-1 h-3.5 w-3.5" />Reschedule</Button>
      </span>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="reschedule-dialog">
          <DialogHeader><DialogTitle>Reschedule appointment</DialogTitle><DialogDescription>{appt.patient_name} · {appt.procedure || appt.type}</DialogDescription></DialogHeader>
          <div className="space-y-3">
            <label className="block text-xs font-semibold">New date<input type="date" className={inp} value={date} onChange={(e) => setDate(e.target.value)} data-testid="reschedule-date" /></label>
            <label className="block text-xs font-semibold">New time<input type="time" className={inp} value={time} onChange={(e) => setTime(e.target.value)} data-testid="reschedule-time" /></label>
            <label className="block text-xs font-semibold">Reason (optional)<input className={inp} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="reschedule-reason" /></label>
            {(appt.history || []).length > 0 && <div className="rounded-lg bg-[#F4FBF7] p-2 text-[11px] text-[#687173] dark:bg-white/5" data-testid="reschedule-history">{appt.history.map((h, i) => <div key={i}>{(h.from_date || "").slice(0, 10)} {h.from_time} → {h.to_date} {h.to_time}{h.reason ? ` · ${h.reason}` : ""} <span className="opacity-70">({h.by})</span></div>)}</div>}
            <Button onClick={save} disabled={busy || !date || !time} className="w-full bg-[#00A85A] text-white hover:bg-[#008F4D]" data-testid="reschedule-save">Save new time</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
